import React, { useState } from 'react'
import InputText from '../ReusableComponents/InputText'
import AddScreenTitle from '../components/AddScreenTitle'
import DropDown from '../ReusableComponents/DropDown'

export default function Booking() {

    
    const addScreenTitle=()=>{}
    //const updateScreenTitle=()=>{}
    
    const handleBlur=()=>{}
    const[paymentdropdown,setPaymentDropdown]=useState([
        {value:'1',label:'Cash'},
        {value:'2',label:'UPI'},
        {value:'3',label:'Debit-Card'},
        {value:'4',label:'Credit-Card'},
        {value:'5',label:'Online-Trasaction'},
    ])
const [payData,setPayData]=useState({
paymentmode:"",
receipt:"",
refnumber:""
})

const handleInputChange=(e)=>{
    const {name, value}= e.target;
    setPayData((prevData)=>({...prevData, [name]: value}));
};

  return (
      <>
      <AddScreenTitle addScreenTitle={addScreenTitle}  title="Booking Form" />
                <form className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 '>

                    <div className=" text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 ">
                    <DropDown
                        name="paymentmode"
                        type={"select-one"}
                        title="Payment Mode"
                        options={paymentdropdown}
                        selectedOption={payData.paymentmode}
                        controlFunc={handleInputChange}
                        controlFuncBlur={handleBlur}
                        placeholder="Select Payment Mode"
                        // tabIndex="5"
                        isRequired={true}
                        errorMessage={"err"}
                    />
                    </div>


                    <InputText
                        inputType="file"
                        title="Transaction Receipt"
                        name="receipt"
                        controlFunc={handleInputChange}
                        controlFuncBlur={""}
                        content={"fd"}
                        placeholder="Please Insert Document"
                        disabled={false}
                        // tabIndex="1"
                        isRequired={false}
                        errorMessage={"errors"}
                    />

                    <InputText
                        inputType="text"
                        title="Reference Number"
                        name="refnumber"
                        controlFunc={handleInputChange}
                        controlFuncBlur={""}
                        content={payData.refnumber}
                        placeholder="Enter Ref Number"
                        disabled={false}
                        // tabIndex="1"
                        isRequired={false}
                        errorMessage={""}
                    />




                </form>
      </>    
  )
}
